import { render } from "./ListProducts.vue?vue&type=template&id=89626262&scoped=true"
import script from "./ListProducts.vue?vue&type=script&lang=js"
export * from "./ListProducts.vue?vue&type=script&lang=js"

import "./ListProducts.vue?vue&type=style&index=0&id=89626262&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89626262"]])

export default __exports__